import { render, staticRenderFns } from "./WalletDetails.vue?vue&type=template&id=761d8476&scoped=true&"
import script from "./WalletDetails.vue?vue&type=script&lang=js&"
export * from "./WalletDetails.vue?vue&type=script&lang=js&"
import style0 from "./WalletDetails.vue?vue&type=style&index=0&id=761d8476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d8476",
  null
  
)

export default component.exports